"use client";

import { usePathname } from 'next/navigation';
import LaunchBanner from '@/components/LaunchBanner';
import MaintenanceBanner from '@/components/MaintenanceBanner';
import CreatorProgramBanner from '@/components/CreatorProgramBanner';
import ShutdownBanner from '@/components/ShutdownBanner';

export default function RootLayoutWrapper({ children }: { children: React.ReactNode }) {
  // const pathname = usePathname();
  // const isDashboard = pathname === '/loading' ||
  //   pathname.startsWith('/highlights') ||
  //   pathname.startsWith('/editor') ||
  //   pathname.startsWith('/clips') ||
  //   pathname.startsWith('/stream') ||
  //   pathname.startsWith('/bot-setup') ||
  //   pathname.startsWith('/subscription') ||
  //   pathname.startsWith('/enterprise') ||
  //   pathname.startsWith('/sign-up') ||
  //   pathname.startsWith('/sign-in') ||
  //   pathname.startsWith('/bounties') ||
  //   pathname.startsWith('/payments');

  return (
    <>
      <ShutdownBanner />
      {/* {!isDashboard && (
        <>
          <LaunchBanner />
          <MaintenanceBanner />
          <CreatorProgramBanner />
        </>
      )} */}
      {children}
    </>
  );
} 